// state
// loading显示
export const LOADING_SHOW = 'loadingShow'
export const LOADING_TITLE = 'loadingTitle'
// mutations.js
export const SET_LOADING = 'setLoading'
